import {
  Box,
  CircularProgress,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { ChangeEventHandler } from 'react';

import { MargeFieldMeetingTypeOption } from '../../hooks/useNonSFDCSchedulerLinkMergeField';

import './customPopoverZIndex.css';

interface NonSFDCSchedulerCustomLinkProps {
  isLoading: boolean;
  meetingTypes: MargeFieldMeetingTypeOption[];
  selectedMeetingType: string | null;
  onMeetingTypeChange: ChangeEventHandler<HTMLInputElement>;
  withCustomLinkLabel?: boolean;
  customLinkLabel?: string;
  onCustomLinkLabelChange?: ChangeEventHandler<HTMLInputElement>;
}

const useStyles = makeStyles({
  label: {
    fontWeight: 'bold',
  },
  root: {
    display: 'block',
    marginBottom: 8,
    height: 32,
    '& > [class*=MuiInputBase-root]': {
      height: 32,
      fontSize: 13,
    },
    '& [class*=MuiSelect-root]:focus': {
      backgroundColor: 'transparent',
    },
  },
  searchInput: {
    paddingRight: 0,
    position: 'relative',
  },
});

export const NonSFDCSchedulerCustomLink = ({
  isLoading,
  meetingTypes,
  selectedMeetingType,
  customLinkLabel,
  withCustomLinkLabel = true,
  onCustomLinkLabelChange,
  onMeetingTypeChange,
}: NonSFDCSchedulerCustomLinkProps): JSX.Element => {
  const classes = useStyles();
  return (
    <>
      {!isLoading && meetingTypes.length > 0 ? (
        <>
          <Box mt={2}>
            <Typography variant="caption" className={classes.label}>
              Meeting type
            </Typography>
            <TextField
              classes={{
                root: classes.root,
              }}
              variant="outlined"
              fullWidth
              select
              id="meeting-type-select"
              value={selectedMeetingType}
              onChange={onMeetingTypeChange}
              SelectProps={{
                MenuProps: {
                  PopoverClasses: {
                    root: 'custom-popover-zindex',
                  },
                },
              }}
            >
              {meetingTypes.map(type => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          {withCustomLinkLabel && (
            <Box mt={2}>
              <Typography variant="caption" className={classes.label}>
                Customize link text
              </Typography>
              <TextField
                classes={{
                  root: classes.root,
                }}
                id="outlined-basic"
                value={customLinkLabel}
                onChange={
                  typeof onCustomLinkLabelChange === 'function'
                    ? onCustomLinkLabelChange
                    : undefined
                }
                variant="outlined"
                fullWidth
              />
            </Box>
          )}
        </>
      ) : (
        <Box
          display="flex"
          width="100%"
          height="11.5rem"
          justifyContent="center"
          alignItems="center"
          gridGap="1rem"
          data-testid="loading-meeting-types"
        >
          <CircularProgress /> Loading options...
        </Box>
      )}
    </>
  );
};
